import { axiosV3 } from "../../../Utils/Axios/axiosV3";

export const sendTicketAnswerService = async (
  userToken: string,
  files: any[],
  text: string,
  ticketId: number | string
) => {
  const data = new FormData();
  data.append("text", text);
  //

  if (files.length > 0) {
    for (let i = 0; i <= files.length - 1; i++) {
      data.append("files[]", files[i].value);
    }
  }
  return axiosV3.post(`/user/ticket-answer/${ticketId}/store`, data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
